// Module
var code = "<h2 id=\"tax-time-is-here\">Tax Time is Here!</h2> <p>Your 2024 tax information is now available online in Account Access. Have questions? Review our Tax FAQ.</p> ";
// Exports
export default code;